import SEO from "@/components/SEO";
import { PRACTITIONER } from "@/data/site";

export function MentionsLegales() {
  return (
    <div className="page-enter pt-32 pb-20" data-testid="page-mentions">
      <SEO title="Mentions légales" description="Mentions légales du site." />
      <div className="container-fxv max-w-3xl">
        <p className="overline gold-line">Mentions légales</p>
        <h1 className="font-serif text-5xl text-[#0C2340] mt-6">
          Mentions légales
        </h1>
        <div className="mt-10 space-y-6 text-[#4A5568] leading-relaxed">
          <p>
            <strong className="text-[#0C2340]">Éditeur du site :</strong>{" "}
            {PRACTITIONER.name}, {PRACTITIONER.title}, {PRACTITIONER.address}.
          </p>
          <p>
            <strong className="text-[#0C2340]">Contact :</strong>{" "}
            {PRACTITIONER.email} — {PRACTITIONER.phoneDisplay}.
          </p>
          <p>
            <strong className="text-[#0C2340]">Numéro ADELI :</strong>{" "}
            communiqué sur demande.
          </p>
          <p>
            <strong className="text-[#0C2340]">Hébergement :</strong>{" "}
            Hébergement professionnel sécurisé conforme aux exigences RGPD.
          </p>
          <p>
            Les informations diffusées sur ce site ont un caractère informatif
            et ne sauraient se substituer à une consultation médicale ou
            psychologique. En cas d'urgence, contactez le 15 ou le 112.
          </p>
        </div>
      </div>
    </div>
  );
}

export function Confidentialite() {
  return (
    <div className="page-enter pt-32 pb-20" data-testid="page-confidentialite">
      <SEO
        title="Politique de confidentialité"
        description="Politique de confidentialité et RGPD."
      />
      <div className="container-fxv max-w-3xl">
        <p className="overline gold-line">Confidentialité</p>
        <h1 className="font-serif text-5xl text-[#0C2340] mt-6">
          Politique de confidentialité
        </h1>
        <div className="mt-10 space-y-6 text-[#4A5568] leading-relaxed">
          <p>
            La présente politique décrit la manière dont les données
            personnelles transmises via ce site sont collectées, utilisées et
            conservées, conformément au RGPD et à la loi Informatique et
            Libertés.
          </p>
          <p>
            <strong className="text-[#0C2340]">Données collectées :</strong>{" "}
            uniquement celles que vous communiquez via le formulaire de contact
            ou la newsletter (nom, email, téléphone, message).
          </p>
          <p>
            <strong className="text-[#0C2340]">Finalité :</strong> répondre à
            votre demande et, le cas échéant, vous envoyer des contenus
            informatifs après votre consentement explicite.
          </p>
          <p>
            <strong className="text-[#0C2340]">Conservation :</strong> les
            données sont conservées le temps nécessaire à la finalité poursuivie
            puis supprimées ou anonymisées.
          </p>
          <p>
            <strong className="text-[#0C2340]">Vos droits :</strong> accès,
            rectification, suppression, opposition. Vous pouvez exercer ces
            droits à tout moment via {PRACTITIONER.email}.
          </p>
          <p>
            <strong className="text-[#0C2340]">Cookies :</strong> seuls les
            cookies strictement nécessaires au fonctionnement du site et, si
            vous l'acceptez, des outils de mesure d'audience anonymisée, sont
            déposés.
          </p>
        </div>
      </div>
    </div>
  );
}
